import React, { PropsWithChildren } from "react";
import { Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

export const StyledContainer = ({ children }: PropsWithChildren<{}>) => {
  const classes = useStyles();

  return <Box className={classes.container}>{children}</Box>;
};

const useStyles = makeStyles({
  container: {
    "& > form": {
      gap: "2rem",
      display: "grid",
      gridTemplateRows: "auto 1fr auto",

      "& .quoteSection": {
        gap: "1rem",
        display: "flex",
        flexDirection: "column",

        "& .arrFields": {
          gap: "0.5rem",
          display: "flex",
          flexDirection: "column",
        },

        "& .arrField": {
          gap: "0.5rem",
          display: "grid",
          gridTemplateRows: "auto 1fr",
        },

        "& .quoteCommonFields": {
          display: "grid",
          rowGap: "0.5rem",
          columnGap: "1rem",
          gridTemplateColumns: "repeat(5, 1fr)",
        },

        "& .quoteFields": {
          display: "grid",
          rowGap: "0.5rem",
          columnGap: "1rem",
          gridTemplateColumns: "repeat(3, 1fr)",
        },
      },
    },
  },
});
